import { endpoint } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/calculatorModals';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'life-expectancy';

/**
 * Life Expectancy Modal Endpoints:
 *     - Ogden Life Expectancy Modal Endpoint.
 *     - Percentage Of Normal Life Expectancy Modal Endpoint.
 *     - Percentage Reduction Life Expectancy Modal Endpoint.
 */
export default {
    /**
     * Ogden Life Expectancy Modal.
     *
     * @return {Promise}
     */
    ogden: data => endpoint(`${PARENT}/${RESOURCE}`, 'ogden', data),
    /**
     * Percentage Of Normal Life Expectancy Modal.
     *
     * @return {Promise}
     */
    percentageOfNormal: data => endpoint(`${PARENT}/${RESOURCE}`, 'percentage-of-normal', data),
    /**
     * Percentage Reduction Life Expectancy Modal.
     *
     * @return {Promise}
     */
    percentageReduction: data => endpoint(`${PARENT}/${RESOURCE}`, 'percentage-reduction', data),
};




// WEBPACK FOOTER //
// ./src/services/api/calculatorModals/lifeExpectancy.js